import { render, staticRenderFns } from "./WebsiteServices.vue?vue&type=template&id=54735bee"
import script from "./WebsiteServices.vue?vue&type=script&lang=js"
export * from "./WebsiteServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports